import { useState, useEffect } from "react";

const ViewDocumentPDF = ({ urlDocument }) => {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    const fetchPDF = async () => {
      try {
        const response = await fetch(urlDocument, {
          headers: { Accept: "application/pdf" },
        });
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch (error) {
        console.error("Error al cargar el PDF:", error);
      }
    };

    fetchPDF();
  }, []);

  return (
    <div
      style={{
        width: 900,
        height: window.innerHeight - 100,
      }}
    >
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Visor de PDF"
        />
      ) : (
        <p>Cargando PDF...</p>
      )}
    </div>
  );
};

export default ViewDocumentPDF;
